import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["activeCheckbox", "categorizationCheckbox"]

  // Handle active/inactive checkbox for categories
  toggleActive(event) {
    const checkbox = event.target
    const categoryId = checkbox.dataset.categoryId
    const isChecked = checkbox.checked

    const requestData = new URLSearchParams()
    requestData.append('category[active]', isChecked)

    fetch(`/panel/categories/${categoryId}`, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': this.getCSRFToken(),
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: requestData
    })
    .then(response => {
      if (response.ok) {
        window.location.reload()
      }
    })
  }

  // Handle categorization checkboxes
  toggleCategorization(event) {
    const checkbox = event.target
    const categoryId = checkbox.dataset.categoryId
    const categorizableType = checkbox.dataset.categorizableType
    const confirmationMessage = checkbox.dataset.confirmationMessage
    const isChecked = checkbox.checked

    // If unchecked, remove all categorizations of this type
    if (!isChecked) {
      if (confirm(confirmationMessage)) {
        this.deleteCategorizations(categoryId, categorizableType, checkbox)
      } else {
        // User cancelled - recheck the checkbox
        checkbox.checked = true
      }
    }
  }

  // Private methods
  deleteCategorizations(categoryId, categorizableType, checkbox) {
    const requestData = new URLSearchParams()
    requestData.append('category_id', categoryId)
    requestData.append('categorizable_type', categorizableType)

    fetch('/panel/categorizations', {
      method: 'DELETE',
      headers: {
        'X-CSRF-Token': this.getCSRFToken(),
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: requestData
    })
    .then(response => {
      if (response.ok) {
        window.location.reload()
      }
    })
  }

  getCSRFToken() {
    const tokenElement = document.querySelector('[name="csrf-token"]')
    return tokenElement ? tokenElement.content : ''
  }
}
